export default __webpack_public_path__ + "static/lesilpo-432cab9c24d90f4bbc0eaa671feaec1d.svg";